import request from '@/utils/request'

const getCurrentUserTrainings = () => {
  return request({
    url: `${process.env.VUE_APP_FACEBOOK_API}/training/current-user-trainings`,
    method: 'get'
  })
}

const resetCurrentUser = (userId) => {
  return request({
    url: `${process.env.VUE_APP_FACEBOOK_API}/training-user/reset/${userId}`,
    method: 'post'
  })
} 

export default {
  getCurrentUserTrainings,
  resetCurrentUser
}
